import { createAction, props } from '@ngrx/store';
import { BudgetControlItemApiModel } from '@/core/models/api/budget-control-item-api.model';
import { ProjectStructureApiModel } from '@/core/models/api/project-structure.model';

export const loadBudgetControlItemsByProject = createAction(
  '[BudgetControlItem] Load By Project',
  props<{ projectId: number }>()
);

export const loadBudgetControlItemsByProjectSuccess = createAction(
  '[BudgetControlItem] Load By Project Success',
  props<{ items: ProjectStructureApiModel[]; projectId: number }>()
);

export const loadBudgetControlItemsByProjectFailure = createAction(
  '[BudgetControlItem] Load By Project Failure',
  props<{ error: any }>()
);
